import * as React from "react";

const SvgLightSnowThunderSun = (props) => (
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" {...props}>
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__a">
        <path d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__b">
        <path
          d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__c">
        <path
          d="M922.177 244.882h-.159a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392h-.069c-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            strokeWidth: 0.999998,
          }}
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__d">
        <path d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__e">
        <path d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83" />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="LightSnowThunderSun_svg__f">
        <path d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0" />
      </clipPath>
    </defs>
    <path
      style={{
        opacity: 0.996721,
        fill: "none",
        stroke: "none",
        strokeWidth: 0.878738,
        strokeLinejoin: "round",
        paintOrder: "stroke fill markers",
      }}
      transform="matrix(1.33333 0 0 1.33333 360 -79.87)"
      d="M-270 59.902h72v72h-72z"
    />
    <g
      clipPath="url(#LightSnowThunderSun_svg__a)"
      transform="matrix(1.33333 0 0 -1.33333 -352.071 757.932)"
      style={{
        fill: "#fec225",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec225",
          fillOpacity: 1,
        }}
      >
        <path
          d="m299.226 529.637-5.267-9.121c-.825-1.429-.154-2.499 1.492-2.378l4.302.316c1.645.121 2.347-.966 1.56-2.416l-4.786-8.806c-.787-1.45-.389-1.779.885-.73l17.302 14.229c1.274 1.048.968 1.837-.679 1.752l-6.611-.338c-1.648-.085-2.321 1.015-1.497 2.444l2.91 5.04c.825 1.429.15 2.599-1.5 2.6l-3.611.004c-1.651.002-3.676-1.166-4.5-2.596"
          style={{
            fill: "#fec225",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
      clipPath="url(#LightSnowThunderSun_svg__b)"
      style={{
        fill: "#fec225",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#fec225",
          fillOpacity: 1,
        }}
      >
        <path
          d="M917.757 257.718c0-7.159 5.805-12.964 12.964-12.964 7.159 0 12.963 5.805 12.963 12.964 0 7.159-5.804 12.962-12.963 12.962-7.159 0-12.964-5.803-12.964-12.962"
          style={{
            fill: "#fec225",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <path
        d="M0 0c5.889 0 10.664 4.774 10.664 10.664S5.889 21.328 0 21.328c-.037 0-.072-.005-.109-.006-.949 8.504-8.158 15.117-16.915 15.117-6.915 0-12.864-4.126-15.528-10.048-.085.001-.168.005-.253.005-7.289 0-13.198-5.909-13.198-13.198C-46.003 5.909-40.094 0-32.805 0"
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none",
        }}
        transform="matrix(1.33333 0 0 -1.33333 64.726 59.2)"
      />
    </g>
    <g
      transform="matrix(1.33333 0 0 -1.33333 -1173.141 363.614)"
      clipPath="url(#LightSnowThunderSun_svg__c)"
      style={{
        fill: "#d5eaf9",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#d5eaf9",
          fillOpacity: 1,
        }}
      >
        <path
          d="M922.177 244.882c-.053.001-.105.003-.159.003a8.287 8.287 0 0 1 0-16.574h20.6a6.696 6.696 0 0 1 0 13.392c-.023 0-.045-.003-.069-.003-.596 5.34-5.122 9.493-10.622 9.493-4.341 0-8.077-2.591-9.75-6.311"
          style={{
            fill: "#d5eaf9",
            stroke: "none",
            fillOpacity: 1,
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunderSun_svg__d)"
      transform="matrix(1.33333 0 0 -1.33333 -574.403 560.346)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M437.971 364.871a4.83 4.83 0 1 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunderSun_svg__e)"
      transform="matrix(1.33333 0 0 -1.33333 -560.62 567.346)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M465.884 364.871a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-4.831 4.83 4.83 4.83 0 0 1-4.831-4.83"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
    <g
      clipPath="url(#LightSnowThunderSun_svg__f)"
      transform="matrix(1.33333 0 0 -1.33333 -577.653 564.03)"
      style={{
        fill: "#eef0f5",
        fillOpacity: 1,
      }}
    >
      <g
        style={{
          fill: "#eef0f5",
          fillOpacity: 1,
        }}
      >
        <path
          d="M452.409 357.884a4.831 4.831 0 0 1 9.662 0 4.83 4.83 0 0 1-9.662 0"
          style={{
            fill: "#eef0f5",
            fillOpacity: 1,
            stroke: "none",
          }}
        />
      </g>
    </g>
  </svg>
);

export default SvgLightSnowThunderSun;
